import styled from "@emotion/styled";

export const Root = styled.div`
  max-width: 1448px;
  margin: 0px auto;
  padding: 24px;
  position: relative;
  .chartHeader {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    gap: 56px;
    justify-content: space-between;
    ul {
      display: flex;
      align-items: center;
      gap: 24px;
      margin: 0;
    }
    li {
      margin: 0;
      margin-left: 0px;
      list-style: none;
      position: relative;
      font-size: 13px;
      font-weight: 600;
      padding: 2px 10px;
      border-radius: 6px;
    }
  }
  .legend {
    position: sticky;
    top: 0;
  }
  .header {
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    margin: 0;
  }
  // hack city!!! this is to highlight remote team members
  .gridThree {
    padding-bottom: 60px;
    .seat {
      :nth-of-type(22),
      :nth-of-type(17) {
        ::before {
          content: "Remote Closers";
          position: absolute;
          left: -3px;
          bottom: -32px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          width: calc(100% + 100% + 100% + 13.5px);
          color: #fff;
          background-color: rgba(120, 120, 200, 1);
          padding: 4px 6px;
          border-radius: 0 0 8px 8px;
          height: 32px;
          top: unset;
          font-size: 16px;
          font-weight: 800;
          z-index: 10;
        }
      }
      :nth-of-type(22)::before {
        background-color: rgba(186, 104, 200, 1);
        content: "JV Closers";
      }
      :nth-of-type(1) {
        border-top-left-radius: 8px;
        border-top: 3px solid rgba(120, 120, 200, 1);
        border-left: 3px solid rgba(120, 120, 200, 1);
      }
      :nth-of-type(2) {
        border-top: 3px solid rgba(120, 120, 200, 1);
      }
      :nth-of-type(3) {
        border-top-right-radius: 8px;
        border-top: 3px solid rgba(120, 120, 200, 1);
        border-right: 3px solid rgba(120, 120, 200, 1);
      }
      :nth-of-type(9) {
        border-left: 3px solid rgba(120, 120, 200, 1);
        /* border-color: red; */
      }
      :nth-of-type(11) {
        border-right: 3px solid rgba(120, 120, 200, 1);
      }
      :nth-of-type(17) {
        border-bottom: 3px solid rgba(120, 120, 200, 1);
        border-left: 3px solid rgba(120, 120, 200, 1);
      }
      :nth-of-type(18) {
        border-bottom: 3px solid rgba(120, 120, 200, 1);
      }
      :nth-of-type(19) {
        border-bottom: 3px solid rgba(120, 120, 200, 1);
        border-right: 3px solid rgba(120, 120, 200, 1);
      }

      :nth-of-type(6) {
        border-top-left-radius: 8px;
        border-top: 3px solid rgba(186, 104, 200, 1);
        border-left: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(7) {
        border-top: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(8) {
        border-top-right-radius: 8px;
        border-top: 3px solid rgba(186, 104, 200, 1);
        border-right: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(14) {
        border-left: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(16) {
        border-right: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(22) {
        border-bottom: 3px solid rgba(186, 104, 200, 1);
        border-left: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(23) {
        border-bottom: 3px solid rgba(186, 104, 200, 1);
      }
      :nth-of-type(24) {
        border-bottom: 3px solid rgba(186, 104, 200, 1);
        border-right: 3px solid rgba(186, 104, 200, 1);
      }
    }
  }
  .grid,
  .gridTwo,
  .gridThree {
    display: grid;
    grid-template-columns: repeat(14, minmax(100px, 1fr));
    grid-template-columns: repeat(14, 1fr);
    grid-template-rows: repeat(6, 100px); /* Adjust row height as needed */
    margin: auto;
    width: 100%;
    max-width: 1440px;
    overflow: auto;
  }
  .gridTwo {
    grid-template-rows: repeat(9, 100px);
  }
  .seat {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
    color: #000;
    height: 100%;
    position: relative;
    transition: all 0.15s ease;
    svg {
      transition: all 0.05s ease;
      cursor: pointer;
      :hover {
        color: rgb(24, 23, 168);
      }
    }
  }
  .seat.funder {
    z-index: 1;
  }
  .innerSeat {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding: 10px;
    position: relative;
    text-align: left;
    transition: all 0.2s ease;
    width: 100%;
    z-index: 1000;
  }
  .seat.empty {
    cursor: default;
  }
  .funder,
  .active {
    z-index: 100;
    color: blue;
    ::before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: 0;
      bottom: 0;
      border: 2px solid blue;
      height: calc(100% + 4px);
      width: calc(100% + 4px);
      z-index: 500;
    }
  }
  .left {
    border-left: 1.5px solid #000;
  }
  .right {
    border-right: 1.5px solid #000;
  }
  .top {
    border-top: 1.5px solid #000;
  }
  .bottom {
    border-bottom: 1.5px solid #000;
  }

  .special {
    background-color: #eee;
  }
  .inactive {
    opacity: 0.2;
    cursor: default;
  }

  .data-modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(0, 0, 0, 0.5); */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
  .data-modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 80vh;
    overflow: auto;
    width: 80%;
    background-color: #fff;
    color: #fff;
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
  @media (min-width: 1360px) {
    .seat {
      font-size: 12px;
    }
  }
`;
